export default __webpack_public_path__ + "static/media/415.6a85f9d9.png";